<div class="content">
  <form [formGroup]="form">
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_TASK.TASK_TITLE' | translate }}</glxy-label>
      <input matInput [formControl]="form.controls.title" [required]="true" id="task-title" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        (variableSelected)="insertVariable('task-title', form.controls.title, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_TASK.TASK_BODY' | translate }}</glxy-label>
      <textarea
        id="task-body"
        matInput
        [formControl]="form.controls.body"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="8"
        [required]="true"
      ></textarea>
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        (variableSelected)="insertVariable('task-body', form.controls.body, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>

    @if (isSMB) {
      <automata-automation-replacement-chips
        label="AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.ASSIGN_TO"
        [dataService]="smbUsersSelectorService"
        [formControl]="form.controls.salesperson"
        [isRequired]="true"
        [multiple]="false"
        [supportedDataTypes]="supportedDataTypes"
        (finishedInitialLoading)="finishedLoadingSelector()"
      ></automata-automation-replacement-chips>
    } @else {
      <automata-automation-replacement-chips
        label="AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.ASSIGN_TO"
        [dataService]="salespersonSelectorService"
        [formControl]="form.controls.salesperson"
        [isRequired]="true"
        [multiple]="false"
        [supportedDataTypes]="supportedDataTypes"
        (finishedInitialLoading)="finishedLoadingSelector()"
      ></automata-automation-replacement-chips>
    }

    <glxy-form-field
      class="task-due-input"
      [required]="true"
      size="small"
      [suffixText]="'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.DAYS' | translate"
    >
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_FULFILLMENT_TASK.TASK_DUE_IN' | translate }}
      </glxy-label>
      <input [formControl]="form.controls.task_days_to_complete" type="number" min="0" max="500" matInput />
    </glxy-form-field>

    <glxy-form-field class="task-priority-input" size="small">
      <glxy-label> {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.TASK_PRIORITY.LABEL' | translate }} </glxy-label>
      <mat-select
        [formControl]="form.controls.task_priority"
        placeholder="{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.TASK_PRIORITY.PLACEHOLDER' | translate }}"
      >
        <mat-option *ngFor="let priority of priorities" [value]="priority.value">
          {{ priority.label | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>

    <glxy-form-field class="task-type-input" size="small">
      <glxy-label> {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.TASK_TYPE.LABEL' | translate }} </glxy-label>
      <mat-select
        [formControl]="form.controls.task_type"
        placeholder="{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.TASK_TYPE.PLACEHOLDER' | translate }} "
      >
        <mat-option *ngFor="let taskType of taskTypes" [value]="taskType.value">
          {{ taskType.label | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>

    <automata-automation-replacement-chips
      [label]="'COMMON.TAGS' | translate"
      [dataService]="tagsService"
      [formControl]="form.controls.tags"
      [isRequired]="false"
      [multiple]="true"
      [supportDataPassing]="false"
      (finishedInitialLoading)="finishedLoadingSelector()"
      [extraData]="{ fieldId: activityTags, objectType: 'Activity' }"
      [allowCustomValues]="true"
    ></automata-automation-replacement-chips>
  </form>
</div>
